import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useForm = (data, fetchTable, hideModal) => {
    const [values, setValues] = useState({
        ...data
    });
    const [loading, setLoading] = useState(false);

    const handleChangeSetValue = (name, value) => {
        setValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    const handleSubmit = (val) => {
        const params = {
            whatsapp_service_id: val?.whatsapp_service_id,
            api_key: val?.api_key,
            wa_number: val?.wa_number,
            key_number: val?.key_number,
        };

        let endpoint = "whatsapp/phone-integration";
        let method = "POST";

        if (data?.id) {
            endpoint = `${endpoint}/${data?.id}`;
            method = "PUT";
        }

        setLoading(true);

        _setAxios(endpoint, method, params)
            .then(resp => {
                if (resp.status) {
                    _success('topRight', 'Success', resp.data.message);
                    fetchTable(true);
                    hideModal();
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    return {
        values,
        loading,
        handleChangeSetValue,
        handleSubmit,
    };
};

export default useForm;
